import { messages as englishMessages } from './en';
import { messages as portugueseMessages } from './pt';

const messages = {
  ...portugueseMessages,
  ...englishMessages,
};

export { messages };
